export type ResetValueType<T = any> = string | string[] | number | number[] | T | T[];

export const InputMultipleValues = {
  SingleSelect: '-1',
  MultipleSelect: ['-1'],
};
